import { EntityType, Module } from "@/constants";

import { AxiosResponse } from "axios";
import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";

export interface SupportMessagesList {
  sources: [string];
  question: string;
  answer: string;
  userId: string;
  createdAt: Date;
  updatedAt: Date;
  id: string;
}
const SupportAIService = {
  post: (params: any): Promise<AxiosResponse<SupportMessagesList>> =>
    requests(SERVICE_NAME.SUPPORT_AI_API)
      .log({
        module: Module.SUPPORT_AI,
        entityType: EntityType.OTHERS,
        entityId: params.userId,
      })
      .post("support-portal", params)
      .catch((err) => err),

  fetch: (userId: any) =>
    requests(SERVICE_NAME.SUPPORT_AI_API)
      .log({
        module: Module.SUPPORT_AI,
        entityType: EntityType.OTHERS,
        entityId: userId,
      })
      .get(`support-portal/queries/${userId}`),

  update: (payload: any, messageId: string) =>
    requests(SERVICE_NAME.SUPPORT_AI_API)
      .log({
        module: Module.SUPPORT_AI,
        entityType: EntityType.OTHERS,
        entityId: payload.userId,
      })
      .put(`support-portal/${messageId}`, payload),
};

export default SupportAIService;
